module.exports = __webpack_public_path__ + "img/tiktok.8af4722f.svg";